/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type CommentSeenContextLocal = {
    readonly enableCommentSeen: boolean;
    readonly " $refType": "CommentSeenContextLocal";
};
export type CommentSeenContextLocal$data = CommentSeenContextLocal;
export type CommentSeenContextLocal$key = {
    readonly " $data"?: CommentSeenContextLocal$data;
    readonly " $fragmentRefs": FragmentRefs<"CommentSeenContextLocal">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CommentSeenContextLocal",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "enableCommentSeen",
                    "storageKey": null
                }
            ]
        }
    ],
    "type": "Local",
    "abstractKey": null
} as any);
(node as any).hash = '44e9422f2d937c24f97f097238fdb20b';
export default node;
